export enum ClipContentType {
    SURVEY_RESPONSE = 'survey_response',
    CONVERSATION = 'conversation',
}
